import { Phone, GraduationCap } from "lucide-react";
import { useContent } from "../contexts/ContentContext";

function telHref(raw) {
  if (!raw) return "";
  const cleaned = String(raw).replace(/[^\d+]/g, "");
  return cleaned ? `tel:${cleaned}` : "";
}

export default function Faculty() {
  const { content } = useContent();
  const f = content?.faculty || {};
  if (f.enabled === false) return null;
  const members = f.members || [];

  return (
    <section id="faculty" className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-4">
            <div className="overline">{f.eyebrow}</div>
            <h2 className="font-display mt-3 text-3xl lg:text-4xl font-medium tracking-tight leading-tight">
              {f.heading}
            </h2>
            <p className="mt-4 text-muted-foreground leading-relaxed">{f.body}</p>
            {f.image_url && (
              <div className="mt-8 rounded-2xl overflow-hidden border border-border">
                <img src={f.image_url} alt="Lab work" className="w-full h-[260px] object-cover" />
              </div>
            )}
          </div>

          <div className="lg:col-span-8 grid sm:grid-cols-2 gap-6">
            {members.map((m) => {
              const href = telHref(m.phone);
              return (
                <div
                  key={m.name}
                  data-testid={`faculty-${(m.name || '').toLowerCase().replace(/\s+/g, '-').replace(/\./g, '')}`}
                  className="group rounded-2xl border border-border bg-white p-6 hover:-translate-y-1 hover:shadow-lg hover:border-primary/30 transition-all flex flex-col"
                >
                  <div className="h-12 w-12 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
                    <GraduationCap className="h-5 w-5" />
                  </div>
                  <h3 className="font-display mt-5 text-lg lg:text-xl font-medium tracking-tight">{m.name}</h3>
                  <p className="mt-1 text-sm text-muted-foreground leading-relaxed">{m.role}</p>

                  {href ? (
                    <a
                      href={href}
                      data-testid={`faculty-call-${(m.name || '').toLowerCase().replace(/\s+/g, '-').replace(/\./g, '')}`}
                      className="mt-6 inline-flex items-center justify-center gap-2 h-11 w-full rounded-md bg-primary text-white hover:bg-[#059669] text-sm font-medium transition"
                    >
                      <Phone className="h-4 w-4" />
                      {m.phone}
                    </a>
                  ) : (
                    <div className="mt-6 inline-flex items-center justify-center gap-2 h-11 w-full rounded-md border border-dashed border-border text-muted-foreground text-sm">
                      Add a phone in the CMS
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
